export default function Loading() {
  return (
    <div className="loading">
      <span className="pulse"></span>
    </div>
  )
}